
















import { Component, Prop, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { dateTimeToDisplay } from '@/utils/dateTime'
import { CertificateOfInsurance } from '@/modules/CertificateOfInsurance/interfaces/certificate-of-insurance'
import { AcordForm } from '@/modules/AcordForm/interfaces/acord-form'
import AppQueries from '@/mixins/queries'
import FoldingCard from '@/components/FoldingCard.vue'
import AppFileUploader from '@/components/AppFileUploader.vue'
import AppDialog from '@/components/AppDialog.vue'
import AcordFormList from '@/components/AcordFormList.vue'
import S3Handler from '@/mixins/s3'
import AcordFormDialog from '@/components/AcordFormDialog.vue'

@Component({
  components: {
    FoldingCard,
    AppFileUploader,
    AppDialog,
    AcordFormDialog,
    AcordFormList
  }
})
export default class certificateDetailRelated extends mixins(AppQueries, S3Handler) {
  @Prop({ type: Object as () => CertificateOfInsurance }) readonly certificate!: CertificateOfInsurance

  dateTimeToDisplay = dateTimeToDisplay

  acordFormDialog = {
    show: false
  }

  get acordForms () {
    if (!this.certificate) {
      return []
    }

    const list = this.certificate.acordForms.concat()

    list.sort(function (a: AcordForm, b: AcordForm) {
      return b.version - a.version
    })

    const groupedObj = this.$R.groupBy((file: AcordForm) => {
      return file.acordFormId
    })(list)

    let acordList: AcordForm[] = []

    const diff = (a: string, b: string) => { return Number(b) - Number(a) }

    for (const key of this.$R.sort(diff, this.$R.keys(groupedObj))) {
      acordList = [...groupedObj[key], ...acordList]
    }

    return acordList
  }

  @Emit('refresh')
  onSuccess () {
    // do nothing
  }

  routeToList (routeName: string) {
    this.$router.push({
      name: routeName,
      params: {
        certificateId: this.certificate.id + ''
      }
    })
  }

  routeToPropertyDetail (item: any) {
    this.$router.push({
      name: 'PropertyDetailDetail',
      params: { id: item.id + '' }
    })
  }

  routeToInsuredDetail (item: any) {
    this.$router.push({
      name: 'InsuredDetailDetail',
      params: { id: item.id + '' }
    })
  }

  acordFormNameDisplay (fileName: string, version: number, isLocked: boolean) {
    if (version === 0) {
      return isLocked
        ? fileName + ' - Locked'
        : fileName
    } else {
      return isLocked
        ? fileName + ' - Version ' + version + ' - Locked'
        : fileName + ' - Version ' + version
    }
  }

  showAcordFormDialog (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.acordFormDialog.show = true
  }
  hideAcordFormDialog () {
    this.acordFormDialog.show = false
  }

  stopPreventDefault (e: Event) {
    e.preventDefault()
    e.stopPropagation()
  }

  mergeCellMethod ({ row, _rowIndex, column, visibleData }: any) {
    const fields = ['name']
    const cellValue = row[column.property]
    if (cellValue && fields.includes(column.property)) {
      const prevRow = visibleData[_rowIndex - 1]
      let nextRow = visibleData[_rowIndex + 1]
      if (prevRow && prevRow['acordFormId'] === row['acordFormId']) {
        return { rowspan: 0, colspan: 0 }
      } else {
        let countRowspan = 1
        while (nextRow && nextRow['acordFormId'] === row['acordFormId']) {
          nextRow = visibleData[++countRowspan + _rowIndex]
        }
        if (countRowspan > 1) {
          return { rowspan: countRowspan, colspan: 1 }
        }
      }
    }
  }

  cellClassName (data: any) {
    if (data.column.property === 'name') {
      return 'file-name-cell'
    }
  }
}
